import { render, staticRenderFns } from "./shengchan.vue?vue&type=template&id=0273fa79&scoped=true&"
import script from "./shengchan.vue?vue&type=script&lang=js&"
export * from "./shengchan.vue?vue&type=script&lang=js&"
import style0 from "./shengchan.vue?vue&type=style&index=0&id=0273fa79&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0273fa79",
  null
  
)

export default component.exports